import { render, staticRenderFns } from "./ImagesUploader.vue?vue&type=template&id=41d0b1c7"
import script from "./ImagesUploader.vue?vue&type=script&lang=ts"
export * from "./ImagesUploader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports